import { FilteredAccount } from '@interfaces/models';

/**
 * Context object passed to the dynamic form for visibility rules and options providers
 */
export interface AccountTriageFormContext {
  /** Feature toggle for multi-inheritance estate */
  isMultiInheritanceEstateToggle: boolean;
  /** Feature toggle for individual/joint to trust */
  isInheritanceIndividualJointToTrustToggle?: boolean;
  /** List of eligible joint account names for display */
  eligibleJointAccountNames: string[];
  /** Whether to show validation errors */
  showError: boolean;
  /** Currently selected eligible receiving accounts */
  selectedEligibleReceivingAccounts: FilteredAccount[];
  /** Account types selected in document upload (used to filter relationship types) */
  documentUploadAccountTypes?: string[];
  /** Per-field error overrides (true forces error state regardless of validation) */
  fieldErrorOverrides?: { [fieldName: string]: boolean };
}

/**
 * Consolidated UI visibility state for the account triage page
 */
export interface AccountTriageUIState {
  /** Show assume/inherit section for IRA spouse/executor scenarios */
  showAssumeInheritSection: boolean;
  /** Show beneficiary section for per stirpes relationships */
  showBeneSection: boolean;
  /** Show receiving account selection section */
  showReceivingAccountSection: boolean;
  /** Show existing accounts in receiving account section */
  showExistingReceivingAccounts: boolean;
  /** Show "no eligible accounts" banner in main template */
  showNoAccountsBanner: boolean;
  /** Show "no eligible accounts" banner inside receiving form */
  showNoAccountsBannerInReceivingForm: boolean;
  /** Show "Transfer another account" button */
  showTransferAnotherAccountButton: boolean;
}

/**
 * Default UI state - all sections hidden
 */
export const DEFAULT_UI_STATE: AccountTriageUIState = {
  showAssumeInheritSection: false,
  showBeneSection: false,
  showReceivingAccountSection: false,
  showExistingReceivingAccounts: false,
  showNoAccountsBanner: false,
  showNoAccountsBannerInReceivingForm: false,
  showTransferAnotherAccountButton: false,
};
